var StickyInit;

(function ($) {

	const selectors = {
		box: '[data-sticky]',
		content: '[data-sticky-content]'
	}


	StickyInit = class StickyInit {
		constructor() {
			this.init();
		}
		init() {
			$(selectors.box).each((i, el) => {
				new Sticky(el);
			})
		}
	}

	class Sticky {
		constructor(element) {
			this.box = element;

			this.init();
			this.resize();
			this.bind();

			// console.log(this);

		}
		init() {

			this.content = $(selectors.content, this.box).get(0);
			$(this.content).css({ 'position': 'absolute', 'top': 0 });
			$(this.box).css({ 'position': 'relative' });
			// this.amount = $(this.box).attr('data-amount') ? parseInt( $(this.box).attr('data-amount') ) : 0;
			// this.rate = 0.5;

		}
		bind() {
			$(window).scroll((e) => { this.scroll(); });
			$(window).resize((e) => { this.resize(); });
		}

		resize() {

			this.headerHeight = $('#site-header').outerHeight() + $('[data-fixed-nav]').outerHeight();
			this.bodyHeight = $(window).height() - this.headerHeight;

			this.contentHeight = $(this.content).outerHeight(true);

			this.startScroll = $(this.box).offset().top - this.headerHeight;
			this.endScroll = $(this.box).offset().top + $(this.box).outerHeight() - $(window).height();


			// if( this.contentHeight < this.bodyHeight ){
			this.startScroll -= (this.bodyHeight - this.contentHeight) / 2;
			// }
			this.endScroll += (this.bodyHeight - this.contentHeight) / 2;


			var temp_css = $(this.content).css('position');
			$(this.content).css('position', 'static');
			this.contentTop = $(this.content).position().top;
			$(this.content).css('position', temp_css);


			// $(this.box).css('padding-bottom', this.amount*this.rate);
			$(this.box).css('min-height', this.contentHeight);

			// console.log(this.contentTop);


			// console.log(this);
		}

		scroll() {


			var scroll = $(window).scrollTop();
			scroll = Math.max(this.startScroll, Math.min(scroll, this.endScroll));
			scroll -= this.startScroll;

			// console.log(this.startScroll, $(window).scrollTop(), this.endScroll, scroll);

			// var new_scroll = Math.floor( scroll * this.rate );
			// console.log(scroll, new_scroll);

			$(this.content).css({ 'top': scroll });





			// if( scroll >= this.amount ){
			// 	$(this.content).css({'position': 'absolute', 'top': this.contentTop + scroll });
			// }
			// else
			//  if( scroll > 0 ){
			// 	$(this.content).css({'position': 'fixed', 'top': this.contentTop - scroll});
			// }
			// else {
			// 	$(this.content).css({'position': 'static'});
			// 	
			// }
			// $(this.content).css('transform', 'translateY('+new_scroll+'px) translateZ(0)');
			// $(this.content).css('padding-top', new_scroll);

		}


	}

})(jQuery);


export default StickyInit;